// extracted by mini-css-extract-plugin
export default {"history":"Purpose_history__Wen4C","history_left":"Purpose_history_left__g7Ktj","history_right":"Purpose_history_right__cYTni","conclusion":"Purpose_conclusion__IyH1o"};